import { render, staticRenderFns } from "./GNotificationItem.vue?vue&type=template&id=5e0d3433&"
import script from "./GNotificationItem.vue?vue&type=script&lang=ts&"
export * from "./GNotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./GNotificationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports